import moment from 'moment'
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { useMediaQuery } from 'react-responsive'
import { formatCurrency, formatCurrencyNoVnd } from '../../utils'
import http from '../../utils/http'
import ExportCSV from '../ExportCSV/ExportCSV'
import Filter from '../Filter/Filter'
import Header from '../Header/Header'
import CreateTransactionForm from './CreateTransactionForm'


const ITEMS_PER_PAGE = 7

const Transaction = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 })

  const [currentPage, setCurrentPage] = useState(0)
  const [currentItems, setCurrentItems] = useState([])
  const [pageCount, setPageCount] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)
  const [listKiosk, setListKiosk] = useState([])
  const [listShift, setListShift] = useState([])
  const [transactions, setTransactions] = useState([])
  const [filteredTrans, setFilteredTrans] = useState([])
  const [isShowImportForm, setShowImportForm] = useState(false)
  const [cards, setCards] = useState([])

  const getSettings = async () => {
    try {
      const kiosktotal = sessionStorage.getItem('kioskTotal');

      if (kiosktotal) {
        const kiosks = [];

        for (let i = kiosktotal - 1; i >= 0; i--) {
          const kioskname = sessionStorage.getItem('kioskName' + i);
          const kioskId = sessionStorage.getItem('kioskId' + i);

          if (kioskname) {
            const kiosk = { kioskId: kioskId, kioskName: kioskname };
            kiosks.push(kiosk);
          }
        }
        setListKiosk(kiosks);
      }

      sessionStorage.setItem('transload', '0');
    } catch (error) {
      console.log('error: ', error);
    }
  };

  useEffect(() => {
    getSettings()
  }, [])

  const [filterTransaction, setFilterTransaction] = useState({
    licensePlate: '',
    paymentMethod: '',
    kioskId: '',
    startDate: null,
    employerId: '',
    endDate: null
  })

  const handleChangeFilterTransaction = (value) => {
    setFilterTransaction({
      ...filterTransaction,
      ...value
    })
  }

  const handleResetFilter = () => {
    setFilterTransaction({
      licensePlate: '',
      paymentMethod: '',
      kioskId: '',
      startDate: null,
      employerId: '',
      endDate: null
    })
  }

  const totalTransactions = transactions.length

  const handlePageClick = (event) => {
    const newOffset = (event.selected * ITEMS_PER_PAGE) % totalTransactions
    setItemOffset(newOffset)
    setCurrentPage(event.selected)
  }

  const getCard = (kioskid) => {
    return new Promise(async (resolve, reject) => {
      try {
        const getResp = await http.get('/cards');
        if (getResp.data.length > 0) {
          const cards = getResp.data.map((element) => element); // Map to collect cards
          console.log('getCard', getResp.data);
          resolve(cards); // Resolve the cards array
        } else {
          console.log('No cards found');
          resolve([]); // Resolve with an empty array if no data is found
        }
      } catch (error) {
        console.error('Error fetching cards:', error);
        reject(error); // Reject the promise with the error
      }
    });
  };

  useEffect(() => {
    const endOffset = itemOffset + ITEMS_PER_PAGE
    console.log("filter transaction ", filterTransaction)
    const filteredTransactions = transactions
      .filter((transaction) => {
        if (filterTransaction.startDate) {
          return moment(transaction.checkInTime).isSame(
            moment(new Date(filterTransaction.startDate).getTime()),
            'day'
          )
        }
        return true
      })
      .filter((transaction) => {
        if (filterTransaction.employerId) {
          return transaction.userId === filterTransaction.employerId
        }
        return true
      })
      .filter((transaction) => {
        if (filterTransaction.endDate) {
          return moment(transaction.checkOutTime).isSame(
            moment(new Date(filterTransaction.endDate).getTime()),
            'day'
          )
        }
        return true
      })
      .filter((transaction) => {
        if (filterTransaction.kioskId) {
          return transaction.kioskId === filterTransaction.kioskId
        }
        return true
      })
      .filter((transaction) => {
        if (filterTransaction.licensePlate) {
          return transaction.licensePlate === filterTransaction.licensePlate
        }
        return true
      })
      .filter((transaction) => {
        if (filterTransaction.zmaTrans) {
          return transaction.zmaTrans === filterTransaction.zmaTrans
        }
        return true
      })
      .filter((transaction) => {
        if (filterTransaction.paymentMethod) {
          return transaction.paymentMethod === filterTransaction.paymentMethod
        }
        return true
      })

    setFilteredTrans(filteredTransactions)
    setCurrentItems(filteredTransactions.slice(itemOffset, endOffset))

    setPageCount(Math.ceil(filteredTransactions.length / ITEMS_PER_PAGE))
  }, [transactions, itemOffset, filterTransaction])

  useEffect(() => {
    setCurrentPage(0)
    setItemOffset(0)
  }, [filterTransaction])

  const getTransactions = async (kioskid, userCards) => {
    try {
      const transArr = []
      const resp = await http.post('/transactions', { kioskId: kioskid })
      if (resp.data.length > 0) {
        resp.data.forEach((element) => {
          const cardInfo = userCards.find((card) => card.userid === element.userId)
          element.cardName = cardInfo?.username
          element.cardDepartment = cardInfo?.department
          transArr.push(element)
        })
      }
      console.log("transactions", transArr)
      setTransactions(transArr)
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    ; (async () => {
      try {
        const kiosktotal = sessionStorage.getItem('kioskTotal')
        const transloadpost = sessionStorage.getItem('transloadpost')

        getCard("No need here").then((cards) => {
          if (transloadpost == null && transloadpost !== '0') {
            sessionStorage.setItem('transloadpost', '0')
            console.log('Kiosk total ', kiosktotal);
            for (var i = 0; i < kiosktotal; i++) {
              const kioskid = sessionStorage.getItem('kioskId' + i)
              console.log('Get transaction from id ', kioskid)
              getTransactions(kioskid, cards)
            }
          }
        })
      } catch (error) {
        console.log('error: ', error)
      }
    })()
  }, [])

  useEffect(() => {
    if (transactions.length !== 0) {
      sessionStorage.removeItem('transload')
      sessionStorage.removeItem('transloadpost')
    }
    const shift = Array.from(
      new Set(
        transactions
          .filter((transaction) => transaction.zmaTrans)
          .map((transaction) => transaction.zmaTrans)
      )
    );
    setListShift(shift)
    console.log("shift", shift)
  }, [transactions])

  const handleDeleteTransaction = async (transactionId) => {
    let deleteTran = {}
    if (window.confirm('Are you sure you want to delete this transaction?')) {
      try {
        console.log("Trans Id : " + transactionId )
        deleteTran = {_id : transactionId}
        try {
          const getResp = await http.post("/transactions/delete", deleteTran);
          console.log("Trans Delete ", getResp.data);
          
          setTransactions(transactions.filter((t) => t._id !== transactionId));
        } catch (error) {
          console.log("error", error);
        }

     

        // Remove the transaction from the state
        //   setTransactions(transactions.filter((t) => t._id !== transactionId));
      } catch (error) {
        console.error('Error deleting transaction:', error);
      }
    }
  };


  const transactionDataExport =
    filteredTrans &&
    filteredTrans.length > 0 &&
    filteredTrans.map((transaction, index) => ({
      id: index + 1,
      licensePlate: transaction?.licensePlate === "0" ? "" : transaction?.licensePlate,
      paymentAmount: formatCurrencyNoVnd(transaction?.paymentAmount),
      paymentMethod:
        transaction?.paymentMethod === 'CASH'
          ? 'Tiền mặt'
          : transaction?.paymentMethod,
      kioskId: transaction?.kioskId,
      userId: transaction?.userId ? transaction?.userId : "",
      createdAt: transaction?.createdAt ? moment(transaction?.createdAt).format('DD/MM/YYYY HH:mm:ss') : "",
      checkInTime: transaction?.checkInTime ? moment(transaction?.checkInTime).format('DD/MM/YYYY') : "",
      zmaTrans: transaction?.zmaTrans ? transaction.zmaTrans : "",
      cardName: transaction?.cardName ? transaction.cardName : "",
      cardDepartment: transaction?.cardDepartment ? transaction.cardDepartment : "",
      checkOutTime: transaction?.checkOutTime ? moment(transaction?.checkOutTime).format('DD/MM/YYYY HH:mm:ss') : "",
      updatedAt: transaction?.updatedAt ? moment(transaction?.updatedAt).format('DD/MM/YYYY HH:mm:ss') : "",
      updateByRole: transaction?.updateByRole
    }))

  const wscols =
    transactionDataExport && transactionDataExport.length > 0
      ? [
        {
          wch: Math.max(
            ...transactionDataExport.map(
              (transaction) => transaction.id.length
            )
          )
        },
        {
          wch:
            Math.max(
              ...transactionDataExport.map(
                (transaction) => transaction.kioskId.length
              )
            ) + 10
        },
        {
          wch:
            Math.max(
              ...transactionDataExport.map(
                (transaction) => transaction.licensePlate.length
              )
            ) + 5
        },
        {
          wch:
            Math.max(
              ...transactionDataExport.map(
                (transaction) => transaction.createdAt.length
              )
            ) + 7
        },

        {
          wch:
            Math.max(
              ...transactionDataExport.map(
                (transaction) => transaction.checkInTime.length
              )
            ) + 7
        }
        ,
        {
          wch:
            Math.max(
              ...transactionDataExport.map(
                (transaction) => transaction.zmaTrans.length
              )
            ) + 7
        }
        ,
        {
          wch:
            Math.max(
              ...transactionDataExport.map(
                (transaction) => transaction.checkOutTime.length
              )
            ) + 7
        },
        {
          wch:
            Math.max(
              ...transactionDataExport.map(
                (transaction) => transaction.userId.length
              )
            ) + 7
        }
        ,
        {
          wch:
            Math.max(
              ...transactionDataExport.map(
                (transaction) => transaction.cardName.length
              )
            ) + 7
        }
        ,
        {
          wch:
            Math.max(
              ...transactionDataExport.map(
                (transaction) => transaction.cardDepartment.length
              )
            ) + 7
        }
      ]
      : []

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      {isMobile && <Header />}
      <div
        style={isMobile ? { marginTop: '55px' } : {}}
        className="post d-flex flex-column-fluid"
        id="kt_post"
      >
        <div id="kt_content_container" className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <div className="col-xl-12">
              <div className="card card-xl-stretch mb-5 mb-xl-8">
                <div className="card-header border-0 pt-5">
                  <div className="w-100 card-title d-flex align-items-center justify-content-between">
                    <span className="card-label fw-bolder fs-3">GIAO DỊCH</span>
                    <Filter
                      listKiosk={listKiosk}
                      filterTransaction={filterTransaction}
                      onResetFilter={handleResetFilter}
                      onChangeFilterTransaction={handleChangeFilterTransaction}
                      listShift={listShift}
                    />
                    <ExportCSV
                      csvData={transactionDataExport}
                      fileName={`Danh_sach_giao_dich_xuat_${moment().format(
                        'DD_MM_YYYY'
                      )}`}
                      wscols={wscols}
                      headerTitle={[
                        'id',
                        'kioskId',
                        'licensePlate',
                        'createdAt',
                        'checkInTime',
                        'zmaTrans',
                        'checkOutTime',
                        'userId',
                        'cardName',
                        'cardDepartment'
                      ]}
                      headerTranslate={[
                        {
                          id: 'STT',
                          licensePlate: 'Số ô',
                          kioskId: 'Tên máy',
                          createdAt: 'Thời gian tạo',
                          checkInTime: 'Ngày nhận',
                          zmaTrans: 'Ca Nhận',
                          checkOutTime: 'Thời gian nhận',
                          userId: 'Mã nhân viên nhận',
                          cardName: 'Tên nhân viên',
                          cardDepartment: 'Phòng ban'
                        }
                      ]}
                    />
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={(e) => {
                        setShowImportForm(true)
                        }}
                      >
                        Nhập đơn
                      </button>
                      </div>
                    </div>

                    <div className="card-body py-3">
                      <div className="table-responsive">
                      <table className="table-transaction table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                        <thead>
                        <tr className="fw-bolder text-muted">
                          <th className="min-w-100px text-center">STT</th>
                          <th className="min-w-100px text-center">
                          Tên Máy
                          </th>
                          <th className="min-w-100px text-center">
                          Ô lấy
                          </th>
                          <th className="min-w-150px text-center">Thời gian tạo</th>
                          <th className="min-w-150px text-center">Ngày nhận</th>
                          <th className="min-w-150px text-center">Ca nhận</th>
                          <th className="min-w-150px text-center">Thời gian thực nhận</th>
                          <th className="min-w-150px text-center">Mã nhân viên nhận</th>
                          <th className="min-w-100px text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {currentItems.map((transaction, index) => (
                          <tr>
                          <td className="text-center">
                            <span className="text-dark d-block fs-6">
                            {itemOffset + index + 1}
                            </span>
                          </td>
                          <td className="text-center">
                            {
                            listKiosk.find(
                              (kiosk) =>
                              kiosk.kioskId === transaction.kioskId
                            )?.kioskName
                            }
                          </td>
                          <td className="text-center">
                            <div className="d-flex align-items-center justify-content-center">
                            <span className="mx-3 fw-bold text-dark d-block fs-6">
                              {transaction.licensePlate == 0 ? "" : transaction.licensePlate}
                            </span>
                            </div>
                          </td>
                          <td className="text-center">
                            <span className="text-dark d-block fs-6">
                            {
                              transaction.createdAt ? moment(transaction.createdAt).local().format(
                              'HH:mm:ss'
                              ) : ""}
                            </span>
                            <br />
                            <span className="text-dark d-block fs-6">
                            {transaction.createdAt ? moment(transaction.createdAt).local().format(
                              'DD/MM/YYYY'
                            ) : ""}
                            </span>
                          </td>
                          <td className="text-center">

                            <span className="text-dark d-block fs-6">
                            {transaction.checkInTime ? moment(transaction.checkInTime).local().format(
                              'DD/MM/YYYY'
                            ) : ""}
                            </span>
                          </td>
                          <td className="text-center">
                            <span className="text-dark d-block fs-6">
                            {transaction.zmaTrans}
                            </span>
                          </td>
                          <td className="text-center">
                            <span className="text-dark d-block fs-6">
                            {
                              transaction.checkOutTime ? moment(transaction.checkOutTime).local().format(
                              'HH:mm:ss'
                              ) : ""}
                            </span>
                            <br />
                            <span className="text-dark d-block fs-6">
                            {transaction.checkOutTime ? moment(transaction.checkOutTime).local().format(
                              'DD/MM/YYYY'
                            ) : ""}
                            </span>
                          </td>
                          <td className="text-center">
                            <span className="text-dark d-block fs-6">
                            {transaction.userId}
                            </span>
                          </td>
                          <td className="text-center">
                            <button
                            className="btn btn-danger"
                            onClick={() => handleDeleteTransaction(transaction._id)}
                            >
                            Delete
                            </button>
                          </td>

                          </tr>
                        ))}
                        </tbody>
                      </table>
                      </div>
                    </div>
                    </div>
                  </div>
                  {
                    isShowImportForm && (
                    <CreateTransactionForm
                      onFormClose={() => {
                    setShowImportForm(false)
                  }}
                  onFormSubmit={() => {
                    setShowImportForm(false)
                  }}
                />
              )
            }
          </div>
        </div>
      </div>

      <ReactPaginate
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel="<"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
        forcePage={currentPage}
      />
    </div>
  )
}

export default Transaction
